export default __webpack_public_path__ + "static/media/setup.1bf68adb.jpg";